export default class Snippet {

  constructor(modelData, store) {

    if (!modelData) {
      modelData = this.getDefault()
    }

    this.set(modelData)
    this.store = store
  }

  getDefault() {
    return {
      id: null,
      themeId: null,
      translations: {
        de: {
          name: null
        },
        en: {
          name: null
        }
      },
    }
  }

  set(data) {
    Object.assign(this, data)
  }

  getJSON() {
    return {
      id: this.id,
      themeId: this.themeId,
      translations: this.translations,
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/snippet/model.js